import { useState, useEffect, useCallback } from "react";
import { useTranslation } from "react-i18next";
import { ShowHideSubTable } from "../../components/ShowHideSubTable";
import {
  getIngoingTransportSubcategory,
  updateIngoingTransportSubcategory,
  deleteIngoingTransportSubcategory,
  createIngoingTransportSubcategory,
} from "../../../../../apis/Business/IngoingTransportApi";
import SubcategoryBox from "../../components/SubcategoryBox";
import SubHeaderBoxGray from "../../components/SubHeaderBoxGray";
import { useInvalidateQuery } from "../../../../../components/InvalidateQueryContext";
import IngoingTransportTable from "./Table";
import SystemBoundary from "../../components/HeaderBox/SystemBoundary";
import deliveriesIcon from "../../../../../assets/design-revamp-company/company-detail-headers/deliveries-to-us-icon.svg";
import transportDeliveryIcon from "../../../../../assets/design-revamp-company/category-icons/transport_deliveries_icon.svg";
const IngoingTransport = ({ businessId }) => {
  const { t } = useTranslation();
  const [showTable, setShowTable] = useState();
  const [customSubcategories, setCustomSubcategories] = useState([]);
  const [selectedSubcategory, setSelectedSubcategory] = useState(null);
  const [systemBoundaryIngoing, setSystemBoundaryIngoing] = useState();
  const { invalidateKey, resetKey } = useInvalidateQuery();
  const key = "add-new-ingoing-subcategory";
  const deleteKey = "delete-ingoing-subcategory";

  useEffect(() => {
    getIngoingTransportSubcategory({
      businessId: businessId,
      setCustomSubcategory: setCustomSubcategories,
    });
  }, [businessId]);

  const handleSaveSubcategory = (subcategoryData) => {
    if (subcategoryData.objectId) {
      updateIngoingTransportSubcategory(subcategoryData)
        .then(() => {
          setCustomSubcategories((prevSubcategories) =>
            prevSubcategories.map((sub) =>
              sub.id === subcategoryData.objectId ? subcategoryData : sub
            )
          );
        })
        .catch((err) => console.error(err));
    } else {
      createIngoingTransportSubcategory(subcategoryData)
        .then((newSubcategory) => {
          setCustomSubcategories((prevSubcategories) => [
            ...prevSubcategories,
            newSubcategory,
          ]);
        })
        .catch((err) => console.error(err));
    }
  };

  const handleInvalidateAndReset = useCallback(
    (setSubcategoryCustom, setSubcategoryDescCustom, isNewSubcategory) => {
      if (invalidateKey === key || invalidateKey === deleteKey) {
        getIngoingTransportSubcategory({
          businessId: businessId,
          setCustomSubcategory: setCustomSubcategories,
        });
        if (isNewSubcategory) {
          setSubcategoryCustom("");
          setSubcategoryDescCustom("");
        }
      }
      resetKey();
    },
    [businessId, resetKey, invalidateKey, key, deleteKey]
  );

  useEffect(() => {
    handleInvalidateAndReset(
      () => {},
      () => {}
    );
  }, [invalidateKey, businessId, handleInvalidateAndReset]);

  const handleDeleteSubcategory = (subcategoryData) => {
    deleteIngoingTransportSubcategory(subcategoryData)
      .then(() => {
        setCustomSubcategories((prevSubcategories) =>
          prevSubcategories.filter((sub) => sub.id !== subcategoryData.objectId)
        );
      })
      .catch((err) => console.error(err));
  };

  const handleEditSubcategory = (subcategory) => {
    setSelectedSubcategory(subcategory);
  };
  return (
    <div className="component-energy-contents">
      <SubHeaderBoxGray
        title={t("INGOING_TRANSPORT")}
        scope={t("INGOING_TRANSPORT_SCOPE")}
        description={t("INGOING_TRANSPORT_DESC")}
        scopes={[{ scope: t("Scope 3"), filled: true }]}
        graphicIcons={[{ icon: deliveriesIcon }]}
        icon={transportDeliveryIcon}
        number="4.1"
        isNormal={true}
      />
      <SystemBoundary
        businessId={businessId}
        systemBoundary={systemBoundaryIngoing}
        setSystemBoundary={setSystemBoundaryIngoing}
        totalObjCategory="Ingoing Transport"
        customStyles={{ marginTop: "10px" }}
        isTransportDelivery={true}
      />

      <div style={{ marginTop: "12px" }}>
        <SubcategoryBox
          businessId={businessId}
          createSubcategoryApi={handleSaveSubcategory}
          handleInvalidateAndReset={handleInvalidateAndReset}
          isNewSubcategory={true}
        />
        {Array.isArray(customSubcategories) &&
          customSubcategories.length > 0 &&
          customSubcategories.map((sub, index) => {
            return (
              <div style={{ position: "relative" }}>
                <SubcategoryBox
                  key={sub.id}
                  subcategory={sub.name}
                  subcategoryDesc={sub.description}
                  subcategoryId={sub.id}
                  businessId={businessId}
                  createSubcategoryApi={createIngoingTransportSubcategory}
                  deleteSubcategoryApi={handleDeleteSubcategory}
                  updateSubcategoryApi={handleSaveSubcategory}
                  onEdit={handleEditSubcategory}
                  isLetter={false}
                  isNormal={false}
                  baseSequence={"4.1."}
                  index={index}
                  handleInvalidateAndReset={handleInvalidateAndReset}
                />
                {showTable === sub.id && (
                  <IngoingTransportTable
                    businessId={businessId}
                    subcategory={sub.name}
                    subcategory_description={sub.description}
                    subcategoryId={sub.id}
                  />
                )}
                <ShowHideSubTable
                  showTable={showTable}
                  setShowTable={setShowTable}
                  subId={sub.id}
                />
              </div>
            );
          })}
      </div>
    </div>
  );
};

export default IngoingTransport;
